



































































import { Vue, Component, Prop } from 'vue-property-decorator';
import Typography from '@/components/atoms/Typography/Typography.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import SellCoinsCampaignListItem from '@/componentsV2/templates/SellCoinsCampaignListItem/SellCoinsCampaignListItem.vue';
import BoostSalesOfCoinsBanner from '@/componentsV2/templates/BoostSalesOfCoinsBanner/BoostSalesOfCoinsBanner.vue';
import Trigger from '@/componentsV2/molecules/Trigger/Trigger.vue';

import { Campaign } from '@/models/marketingCenter/sellCoins';

import { treatError } from '@/utils';

import SellCoinsService from '@/api/SellCoinsService';
import flagKeys from '@/constants/flagKeys';
import { EProgramStatusStatus } from '@/models/program-status';

@Component({
  components: {
    Typography,
    FlexButton,
    BoostSalesOfCoinsBanner,
    SellCoinsCampaignListItem,
    Trigger
  }
})
export default class SellCoinsCampaignList extends Vue {
  @Prop() canManageSellCoins!: boolean;

  sellCoinsService = new SellCoinsService();

  loading: boolean = true;
  campaigns: Campaign[] = [];
  totalCount: number = 0;
  nextPage: string = '';
  automaticCampaign: any;
  firstRequestIsLoading = false;

  get tPrefix() {
    return 'sellCoins.campaign.list';
  }

  goToNewCampaign() {
    this.$router.push('/sell-coins/campaign/create');
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get hasSellCoinsEnabled() {
    return this.canManageSellCoins && this.businessInfo.sellCoins;
  }

  async getCampaignsList({ isFirstRequest = false } = {}) {
    try {
      if (
        this.firstRequestIsLoading ||
        (this.totalCount > 0 && this.campaigns.length >= this.totalCount)
      ) {
        return;
      }

      if (isFirstRequest) this.firstRequestIsLoading = true;

      this.loading = true;
      this.$showLoaderWithLocker();

      const response = await this.sellCoinsService.listOfCampaigns(
        this.nextPage
      );

      this.campaigns = [...this.campaigns, ...response.data.items];

      if (
        this.$store.getters['flags/getFlags'].includes(
          flagKeys.dashboardSellCoinsAndLoyaltVerify
        )
      ) {
        const rewardStatus =
          (this.$store.getters['business/getRewardStatus'] &&
            this.$store.getters['business/getRewardStatus'].rewardStatus) ||
          '';

        this.automaticCampaign = this.campaigns
          .slice()
          .sort((a, b) =>
            a.incentiveValue && b.incentiveValue
              ? +a.incentiveValue - +b.incentiveValue
              : 0
          )
          .find(
            item =>
              item.automaticallyCreated &&
              (item.incentiveValue &&
                item.incentiveValue >= this.businessInfo.coinRewardPercentage &&
                (rewardStatus &&
                  rewardStatus !== EProgramStatusStatus.INACTIVE))
          );
      } else {
        this.automaticCampaign = null;
      }

      this.$emit('input', this.campaigns);

      this.totalCount = response.data.total;
      this.nextPage = response.data.links.next;
    } catch (e) {
      treatError(e);
    } finally {
      this.loading = false;
      this.$hideLoader();
      if (isFirstRequest) this.firstRequestIsLoading = false;
    }
  }

  mounted() {
    this.getCampaignsList({ isFirstRequest: true });
  }
}
